import type {Fond} from 'src/typings';
import type {FondsDataService} from '../../fonds/services/fonds.data-service';

export class KpRelatedRecordsTablePresenter {
    static presenterName = 'kpRelatedRecordsTablePresenter';

    /*@ngInject*/
    constructor(private fondsDataService: FondsDataService) {
    }

    public async getIncludableFonds(fondId: number): Promise<Fond[]> {
        return this.fondsDataService.getIncludableFonds(fondId);
    }
}